import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.6 7.6v4h.8v-4h-.8zM8 4.4A.8.8 0 108 6a.8.8 0 000-1.6z" /><path fillRule="evenodd" clipRule="evenodd" d="M8 14.4A6.4 6.4 0 108 1.6a6.4 6.4 0 000 12.8zm0 .8A7.2 7.2 0 108 .8a7.2 7.2 0 000 14.4z" /></svg>;